import {
	Box,
	Card,
	Grid,
	Icon,
	IconButton,
	styled,
	Tooltip,
} from '@mui/material';
import { Small } from 'app/components/Typography';
import { useSelector } from 'react-redux';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const StyledCard = styled(Card)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '24px !important',
	background: theme.palette.background.paper,
	[theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
	'& small': { color: theme.palette.text.secondary },
	'& .icon': {
		opacity: 0.6,
		fontSize: '44px',
		color: 'black',
	},
}));

const Heading = styled('h6')(({ theme }) => ({
	margin: 0,
	marginTop: '4px',
	fontSize: '14px',
	fontWeight: '500',
	color: theme.palette.primary.main,
}));

const StatCards = () => {
	const { loginInfo, booking } = useSelector((state) => state.home);
	const cardList = [
		{ name: 'Flight', amount: 3050, icon: 'Inventory' },
		{
			name: 'Total Sales Amount',
			amount: '$80,500',
			icon: 'currency_rupee',
		},
		{
			name: 'Hotel',
			amount: '8.5% Stock Surplus',
			icon: 'hotel',
		},
		{ name: 'Orders to deliver', amount: '305 Orders', icon: 'order' },
	];

	return (
		<Grid container spacing={3} sx={{ mb: '24px' }}>
			{cardList.map((item, index) => (
				<Grid item xs={12} md={6} key={index}>
					<StyledCard elevation={6}>
						<ContentBox>
							{item.icon === 'order' ? (
								<ShoppingCartIcon style={{ fontSize: 30 }} />
							) : (
								<Icon className='icon'>{item.icon}</Icon>
							)}
							<Box ml='12px'>
								<Small>{item.name}</Small>
								<Heading>
									{item.icon === 'currency_rupee'
										? `₹ ${'74856.00'}`
										: item.icon === 'flight'
										? `${booking?.result?.length} Booked`
										: item.icon === 'order'
										? '55 Booked'
										: ''}
								</Heading>
							</Box>
						</ContentBox>

						<Tooltip title='View Details' placement='top'>
							<IconButton>
								<Icon>arrow_right_alt</Icon>
							</IconButton>
						</Tooltip>
					</StyledCard>
				</Grid>
			))}
		</Grid>
	);
};

export default StatCards;
